import { DollarOutlined } from "@ant-design/icons";
import { Typography } from "@mui/material";

const icons = { DollarOutlined };

const finance = {
  id: "finance-accordion",
  title: (
    <Typography variant="h5" component="div">
      Finance
    </Typography>
  ),
  type: "accordion",
  children: [
    {
      id: "invoice",
      title: "Invoices",
      type: "item",
      url: "/invoice-view",
      icon: icons.DollarOutlined,
    },
    {
      id: "stakeholder-account",
      title: "Stakeholder Accounts",
      type: "item",
      url: "/stakeholder-account-view",
      icon: icons.DollarOutlined,
    },
    {
      id: "vat-analysis",
      title: "VAT Analysis",
      type: "item",
      url: "/vat-analysis-view",
      icon: icons.DollarOutlined,
    },
  ],
};

export default finance;
